import styled from 'styled-components';
import { breakpoints } from '@/styles/breakpoints';
import {
  StoryAttributeContent,
  StoryContent,
  StoryFooter,
  StoryImage,
  StoryTitle,
  StyledStoryCard,
} from '@/components/Story/Card/styles';

const StoriesListSection = styled.section`
  padding: ${({ theme }) => theme.spacings.x10} 0 0;
  overflow: hidden;

  ${breakpoints.MD} {
    padding: ${({ theme }) => theme.spacings.x20} 0 0;
  }
`;

const Title = styled.h2`
  text-align: right;
`;

const Grid = styled.div`
  margin: ${({ theme }) => theme.spacings.x4} 0;
  display: grid;
  row-gap: ${({ theme }) => theme.spacings.x2};
  column-gap: ${({ theme }) => theme.spacings.x2};

  @media (min-width: 460px) {
    grid-template-columns: repeat(2, 2fr);
  }

  ${breakpoints.MD} {
    row-gap: ${({ theme }) => theme.spacings.x4};
    column-gap: ${({ theme }) => theme.spacings.x4};
    margin: ${({ theme }) => theme.spacings.x6} 0;
  }

  ${breakpoints.MDL} {
    grid-template-columns: repeat(3, 3fr);
    margin: 54px 0;
  }

  ${breakpoints.LG} {
    grid-template-columns: repeat(4, 4fr);
  }

  ${StyledStoryCard} {
    width: unset;

    ${breakpoints.LG} {
      &:nth-child(5n + 6),
      &:nth-child(5) {
        grid-column-start: 1;
        grid-column-end: 3;
      }
      &:nth-child(6n + 6) {
        grid-column-start: 3;
        grid-column-end: 5;
      }

      &:nth-child(5),
      &:nth-child(6n + 6),
      &:nth-child(5n + 6) {
        flex-flow: row nowrap;

        & > * {
          &:first-child {
            ${breakpoints.LG} {
              min-width: 326px;
              width: 326px;
            }

            ${breakpoints.XXLG} {
              min-width: 474px;
              width: 474px;
            }
          }
        }

        ${StoryImage} {
          ${breakpoints.LG} {
            min-width: 270px;
            width: 270px;
            height: 263px !important;
          }

          @media (min-width: 1400px) {
            width: 326px;
            min-width: 326px;
            height: 320px !important;
          }

          ${breakpoints.XXLG} {
            width: 474px;
            min-width: 474px;
            height: 466px !important;
          }
        }

        ${StoryContent} {
          ${breakpoints.LG} {
            border-left: none;
            border-top: 2px solid #fff;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            height: auto !important;

            & > * {
              width: 100%;
            }
            padding: ${({ theme }) =>
              `${parseInt(theme.spacings.x4) - 3}px ${theme.spacings.x4}`};
          }
        }

        ${StoryTitle} {
          ${breakpoints.LG} {
            font-size: ${({ theme }) => theme.fonts.sizes.desktop.large};
          }

          ${breakpoints.XXLG} {
            margin-bottom: ${({ theme }) => parseInt(theme.spacings.x4) + 2}px;
            font-size: 32px;
          }
        }

        ${StoryAttributeContent} {
          ${breakpoints.LG} {
            font-size: ${({ theme }) => theme.fonts.sizes.tablet.regular};
            line-height: ${({ theme }) => theme.fonts.lineHeights.xLarge};
          }

          ${breakpoints.XXLG} {
            font-size: 18px;
          }
        }

        ${StoryFooter} {
          ${breakpoints.LG} {
            margin-top: auto;
          }
        }
      }
    }
  }
`;

const LoadMore = styled.div`
  & > * {
    margin: 0 auto;
  }
`;

export { StoriesListSection, Title, Grid, LoadMore };
